import { combineReducers } from 'redux';
import authenticationReducer from './authentication/authentication_reducer';
import profileReducer from './profile/profile_reducer';
import projectReducer from './projects/projects_reducers';
import buildingReducer from './buildings/buildings_reducers';
import floorReducer from './floor/floor_reducer';
import zoneReducer from './zone/zone_reducer';
import sectionReducer from './section/section_reducer';
import sectionComponentReducer from './section/section_component_reducers';
import transparentMaterialReducer from './material_transparent/material_reducers';
import opaqueMaterialReducer from './material_opaque/material_reducers';
import transparentComponentReducer from './component_transparent/component_reducers';
import opaqueComponentReducer from './component_opaque/component_reducers';
import componentMaterialReducer from './component/component_material_reducers';
import provinceReducer from './provinces/province_reducers';
import buildingTypeReducer from './building_type/building_type_reducers';
import acSplitTypeReducer from './ac_split_type/ac_split_type_reducer';
import packagedSubReducer from './ac_packaged_unit/packaged_sub_reducer';
import acPackagedUnitReducer from './ac_packaged_unit/ac_packaged_unit_reducer';
import acCentralReducer from './ac_central/ac_central_reducer';
import chillerReducer from './ac_central/chiller_reducer';
import waterPumpReducer from './ac_central/water_pump_reducer';
import coolingTowerReducer from './ac_central/cooling_tower_reducer';
import airHandlingUnitReducer from './ac_central/air_handling_unit_reducer';
import boilerReducer from './boiler/boiler_reducers';
import heatPumpReducer from './heat_pump/heat_pump_reducers';
import solarEnergyReducer from './renewable_energy/solar_energy_reducers';
import heatToElectEnergyReducer from './renewable_energy/heat_to_electrical_energy_reducers';
import otherRenewableEnergyReducer from './renewable_energy/other_renewable_energy_reducers';
import otherEquipmentReducer from './other_equipment/equipment_reducers';
import luminaireReducer from './luminaire/luminaire_reducer';
import ballastReducer from './luminaire/ballast_reducer';
import lightingsetReducer from './luminaire/lightingset_reducer';
import envelopRefReducer from './references/envelop_reducer';
import acRefReducer from './references/ac_reducer';
import hotWaterSystemRefReducer from './references/hot_water_system_reducer';
import luminaireRefReducer from './references/luminaire_reducer';
import ballastRefReducer from './references/ballast_reducer';
import evaluationPurposeRefReducer from './references/evaluation_purpose_reducer';
import envelopReducer from './envelop/envelop_reducer';
import zoneAhuReducer from './zone/zone_ahu_reducer';
import zoneLightingSetReducer from './zone/zone_lt_set_reducer';
import zoneACPackagedUnitReducer from './zone/zone_ac_packaged_unit_reducer';
import zoneACSplitTypeReducer from './zone/zone_ac_split_type_reducer';
import vrfIndoorReducer from './vrf/vrf_indoor_reducer';
import vrfOutdoorReducer from './vrf/vrf_outdoor_reducer';
import vrfSystemReducer from './vrf/vrf_system_reducer';
import zoneVRFReducer from './zone/zone_vrf_reducer';
import zoneOtherEquipmentReducer from './zone/zone_other_equipment_reducer';
import projectInspectionReducer from './project_inspection/project_inspection_reducer';
import projectInspectionHistoryReducer from './project_inspection/project_inspection_history_reducer';
import submissionAttachmentReducer from './project_inspection/submission_attachment_reducer';
import submissionCommentReducer from './project_inspection/submission_comment_reducer';
import projectACCentralReducer from './projects/project_ac_central_reducers';
import projectSolarEnergyReducer from './projects/project_solar_energy_reducers';
import projectHeatToElectricalEnergyReducer from './projects/project_heat_to_electrical_energy_reducers';
import projectOtherRenewableEnergyReducer from './projects/project_other_renewable_energy_reducers';
import projectHeatPumpReducer from './projects/project_heat_pump_reducers';
import projectBoilerReducer from './projects/project_boiler_reducers';
import projectLocationReducer from './projects/project_location_reducer';
import notificationReducer from './notification/notification_reducer';
import appReducer from './app/app_reducer';
import statReducer from './stat/stat_reducer';
import projectInvitationReducer from './project_inv/project_inv_reducer';
import projectMemberReducer from './project_member/project_member_reducer';

const referencesReducers = combineReducers({
  envelop: envelopRefReducer,
  ac: acRefReducer,
  hotWaterSystem: hotWaterSystemRefReducer,
  luminaire: luminaireRefReducer,
  ballast: ballastRefReducer,
  evaluationPurpose: evaluationPurposeRefReducer,
});

const materialReducers = combineReducers({
  transparent: transparentMaterialReducer,
  opaque: opaqueMaterialReducer,
});

const componentReducers = combineReducers({
  transparent: transparentComponentReducer,
  opaque: opaqueComponentReducer,
});

const lightingReducers = combineReducers({
  luminaire: luminaireReducer,
  ballast: ballastReducer,
  lightingset: lightingsetReducer,
});

const acReducers = combineReducers({
  splitType: acSplitTypeReducer,
  packagedUnit: acPackagedUnitReducer,
  packagedSub: packagedSubReducer,
  central: acCentralReducer,
  chiller: chillerReducer,
  waterPump: waterPumpReducer,
  coolingTower: coolingTowerReducer,
  airHandlingUnit: airHandlingUnitReducer,
});

const hotWaterSystemReducers = combineReducers({
  boiler: boilerReducer,
  heatPump: heatPumpReducer,
});

const projectREReducers = combineReducers({
  solarEnergy: projectSolarEnergyReducer,
  heatToElectricalEnergy: projectHeatToElectricalEnergyReducer,
  otherRenewableEnergy: projectOtherRenewableEnergyReducer,
});

const renewableEnergyReducers = combineReducers({
  solarEnergy: solarEnergyReducer,
  heatToElectricalEnergy: heatToElectEnergyReducer,
  otherEnergy: otherRenewableEnergyReducer,
});

export default combineReducers({
  authentication: authenticationReducer,
  profile: profileReducer,
  project: projectReducer,
  building: buildingReducer,
  projectACCentral: projectACCentralReducer,
  projectRE: projectREReducers,
  projectHeatPump: projectHeatPumpReducer,
  projectBoiler: projectBoilerReducer,
  floor: floorReducer,
  zone: zoneReducer,
  zoneAhu: zoneAhuReducer,
  zoneACPackagedUnit: zoneACPackagedUnitReducer,
  zoneACSplitType: zoneACSplitTypeReducer,
  vrfIndoor: vrfIndoorReducer,
  vrfOutdoor: vrfOutdoorReducer,
  vrfSystem: vrfSystemReducer,
  zoneVRF: zoneVRFReducer,
  zoneLightingSet: zoneLightingSetReducer,
  zoneOtherEquipment: zoneOtherEquipmentReducer,
  section: sectionReducer,
  section_component: sectionComponentReducer,
  reference: referencesReducers,
  material: materialReducers,
  component: componentReducers,
  componentMaterial: componentMaterialReducer,
  ac: acReducers,
  province: provinceReducer,
  buildingType: buildingTypeReducer,
  hotWaterSystem: hotWaterSystemReducers,
  renewableEnergy: renewableEnergyReducers,
  other_equipment: otherEquipmentReducer,
  lighting: lightingReducers,
  envelop: envelopReducer,
  projectInspection: projectInspectionReducer,
  submissionAttachment: submissionAttachmentReducer,
  submissionComment: submissionCommentReducer,
  projectInspectionHistory: projectInspectionHistoryReducer,
  projectLocation: projectLocationReducer,
  projectInvitation: projectInvitationReducer,
  projectMember: projectMemberReducer,
  notification: notificationReducer,
  app: appReducer,
  stat: statReducer,
});



// WEBPACK FOOTER //
// ./src/redux/index.js